import {provideApolloClient} from '@vue/apollo-composable';
import {logErrorMessages} from '@vue/apollo-util';

export default defineNuxtPlugin((nuxtApp) => {
  provideApolloClient(useApollo().clients.default);

  nuxtApp.hook('apollo:headers', (headers) => {
    const requestHeaders = useRequestHeaders();
    const event = useRequestEvent();
    const req = event?.node?.req;

    if (req) {
      headers.value['x-forwarded-for'] = requestHeaders['cf-connecting-ip'] ||
          requestHeaders['x-forwarded-for'] ||
          req?.connection.remoteAddress ||
          req?.socket.remoteAddress;
    }
  });

  nuxtApp.hook('apollo:error', (error) => {
    if (process.env.NODE_ENV === 'development') {
      logErrorMessages(error);
    }

    error.graphQLErrors?.map((graphqlError) => {
      if (!['authorization', 'validation'].includes(graphqlError.extensions.category)) {
        throw createError({statusCode: 500, statusMessage: graphqlError.message});
      }
    });
  });
});
